//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyController_addUser,
  Response$AdminCompanyController_addUser$Status$201,
  ResponseContentType$AdminCompanyController_addUser,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminCompanyController_addUser = () =>
  useApiClientMutation<
    Params$AdminCompanyController_addUser,
    Response$AdminCompanyController_addUser$Status$201[ResponseContentType$AdminCompanyController_addUser]
  >({ method: 'AdminCompanyController_addUser' });
